module.exports = __webpack_public_path__ + "static/logo-67c3c97f78004d145f5386aafa29decc.svg";